import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.panel = this.element.querySelector("#goals-panel") || document.getElementById("goals-panel")
    this.handleClickOutside = this.handleClickOutside.bind(this)

    if (this.element.dataset.autoOpen === "true") {
      this.open()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  handleClickOutside(event) {
    if (this.panel && !this.panel.classList.contains("hidden")) {
      if (!this.panel.contains(event.target)) {
        this.close()
      }
    }
  }

  toggle() {
    if (!this.panel) {
      this.panel = this.element.querySelector("#goals-panel") || document.getElementById("goals-panel")
    }

    if (this.panel) {
      this.panel.classList.toggle("hidden")
      if (!this.panel.classList.contains("hidden")) {
        this.panel.classList.add("slide-in-right")
      } else {
        this.panel.classList.remove("slide-in-right")
      }
    }
  }

  close() {
    if (!this.panel) {
      this.panel = this.element.querySelector("#goals-panel") || document.getElementById("goals-panel")
    }

    if (this.panel) {
      this.panel.classList.add("slide-out-right")
      this.panel.classList.remove("slide-in-right")

      setTimeout(() => {
        this.panel.classList.add("hidden")
        this.panel.classList.remove("slide-out-right")
      }, 300)

      document.removeEventListener("click", this.handleClickOutside)
    }
  }

  open() {
    if (!this.panel) {
      this.panel = this.element.querySelector("#goals-panel") || document.getElementById("goals-panel")
    }

    if (this.panel) {
      this.panel.classList.remove("hidden")
      this.panel.classList.add("slide-in-right")

      setTimeout(() => {
        document.addEventListener("click", this.handleClickOutside)
      }, 0)
    }
  }
}